import React from 'react';
import './index.scss';

const Tag = (props) => {
    const {
        appearance,
        children,
        onClick,
        shape,
        type,
    } = props;

    return (
        <div
            className={`tag ${onClick && 'onClick'} ${shape ? `shape_${shape}` : 'shape_default'}`}
            style={{
                backgroundColor: `${appearance === 'outlined' ? 'transparent' : `color-mix(in srgb, var(--${type}, 1), transparent ${appearance?.includes('two-tone') ? '80%' : '0%'})`}`,
                border: `${(appearance === 'outlined' || appearance === 'two-tone-border') ? `1px solid var(--${type ? type : 'main'})` : 'none'}`,
                color: `${appearance === 'filled' ? 'rgba(var(--text-secondary), 1)' : (appearance?.includes('two-tone') ? `var(--${type})` : (type ? `var(--${type})` : 'var(--secondary)'))}`,
                gap: '4px',
                cursor: `${onClick ? 'pointer' : 'default'}`
            }}
            onClick={onClick}
        >
            {children || (type ? type : 'Tag')}
        </div>
    );
}

export default Tag;
